import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import { triggerChat } from '@/utils/chatTrigger';
import ArticleModal from './ArticleModal';

const Blog = ({ posts }) => {
  const [selectedPost, setSelectedPost] = useState(null);

  if (!posts || posts.length === 0) return null;

  return (
    <section className="py-24 bg-navy relative overflow-hidden border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold/10 border border-gold/20 mb-4 text-gold">
            <span className="text-[10px] font-bold tracking-[0.2em] uppercase">Knowledge Base</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-anton uppercase tracking-wide text-white mb-4">
            Insights & <span className="text-gold">Strategies</span>
          </h2>
          <p className="text-gray-400 font-medium text-lg">Mastering the art of high-conversion sales automation.</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post, idx) => (
            <motion.div
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="group flex flex-col h-full bg-navy-lighter rounded-2xl border border-white/5 overflow-hidden hover:border-gold/30 transition-all hover:-translate-y-1 shadow-xl relative"
            >
              {/* Decorative Gradient */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-gold/5 blur-3xl group-hover:bg-gold/10 transition-colors" />

              <div className="p-8 flex flex-col h-full relative z-10">
                <div className="flex items-center gap-2 text-gold text-[10px] font-bold uppercase tracking-[0.2em] mb-4">
                  <SafeIcon icon={FiIcons.FiCalendar} className="text-xs" />
                  <span>{post.displayDate}</span>
                </div>
                
                <h3 
                  onClick={() => setSelectedPost(post)}
                  className="text-2xl font-anton uppercase tracking-wide text-white mb-4 leading-tight group-hover:text-gold transition-colors cursor-pointer"
                >
                  {post.headline}
                </h3>
                
                <p className="text-gray-400 font-medium mb-8 line-clamp-4 flex-grow leading-relaxed">
                  {post.article}
                </p>

                <div className="pt-6 border-t border-white/5 flex items-center justify-between">
                  <button 
                    onClick={() => setSelectedPost(post)}
                    className="inline-flex items-center gap-2 text-white font-bold uppercase tracking-widest text-xs hover:text-gold transition-colors group/btn"
                  >
                    Learn More
                    <SafeIcon icon={FiIcons.FiArrowRight} className="group-hover/btn:translate-x-1 transition-transform" />
                  </button>

                  <a 
                    href={post.ctaLink === '#' ? undefined : post.ctaLink}
                    onClick={post.ctaLink === '#' ? (e) => { e.preventDefault(); triggerChat(); } : undefined}
                    className="text-[10px] bg-white/5 text-gray-400 px-3 py-1 rounded-full uppercase font-bold tracking-widest hover:bg-gold hover:text-navy transition-all"
                  >
                    {post.ctaText}
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <ArticleModal 
        post={selectedPost} 
        isOpen={!!selectedPost} 
        onClose={() => setSelectedPost(null)} 
      />
    </section>
  );
};

export default Blog;